import { FhsApi } from "../../../services/axios";

export const _user = {
  mutations: User__MUTATIONS
};

const User__MUTATIONS = {
  login({ dispatch }, payload) {
    if (payload.byEds) {
      dispatch("loginByUsername", payload);
    } else {
      dispatch("loginByEds", payload);
    }
  },
  loginByUsername({ commit }, { username, password }) {
    FhsApi.auth.login(username, password).then(res => {
      commit("SetUserData", res.data.result);
    });
  },
  loginByEds() {}
};
